import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustSignals = () => {
  const certifications = [
    {
      id: 1,
      name: 'Uganda Communications Commission',
      description: 'Licensed ICT Service Provider',
      icon: 'Shield',
      verified: true
    },
    {
      id: 2,
      name: 'ISO 27001 Certified',
      description: 'Information Security Management',
      icon: 'Lock',
      verified: true
    },
    {
      id: 3,
      name: 'Uganda Registration Services Bureau',
      description: 'Registered Company in Uganda',
      icon: 'Building',
      verified: true
    }
  ];

  const partnerships = [
    {
      id: 1,
      name: 'Microsoft Partner',
      logo: 'https://images.unsplash.com/photo-1633419461186-7d40a38105ec?w=100&h=60&fit=crop',
      description: 'Certified Microsoft Solutions Partner'
    },
    {
      id: 2,
      name: 'Cisco Partner',
      logo: 'https://images.unsplash.com/photo-1606868306217-dbf5046868d2?w=100&h=60&fit=crop',
      description: 'Authorized Cisco Technology Partner'
    },
    {
      id: 3,
      name: 'AWS Partner',
      logo: 'https://images.unsplash.com/photo-1523474253046-8cd2748b5fd2?w=100&h=60&fit=crop',
      description: 'Amazon Web Services Consulting Partner'
    }
  ];

  const testimonials = [
    {
      id: 1,
      name: 'Ministry of Health Uganda',
      role: 'IT Director',
      content: `TechTribes delivered our hospital management system on time and within budget. Their expertise in healthcare ICT solutions is exceptional.`,
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=50&h=50&fit=crop&crop=face'
    },
    {
      id: 2,
      name: 'Uganda Development Bank',
      role: 'Chief Technology Officer',
      content: `Outstanding network infrastructure implementation. TechTribes' team understood our banking security requirements perfectly.`,avatar: 'https://images.unsplash.com/photo-1494790108755-2616b612b786?w=50&h=50&fit=crop&crop=face'
    }
  ];

  const securityFeatures = [
    {
      icon: 'ShieldCheck',
      title: 'Secure Data Protection',
      description: 'Your information is encrypted and stored securely'
    },
    {
      icon: 'Lock',
      title: 'Privacy Guaranteed',
      description: 'We never share your data with third parties'
    },
    {
      icon: 'UserCheck',
      title: 'Verified Accounts',
      description: 'All accounts go through verification process'
    },
    {
      icon: 'Phone',
      title: '24/7 Support',
      description: 'Local Ugandan support team available anytime'
    }
  ];

  return (
    <div className="space-y-8">
      {/* Security Features */}
      <div className="bg-card rounded-lg p-6 border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="Shield" size={20} className="mr-2 text-primary" />
          Your Security is Our Priority
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {securityFeatures?.map((feature) => (
            <div key={feature?.icon} className="flex items-start space-x-3">
              <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={feature?.icon} size={16} className="text-primary" />
              </div>
              <div>
                <h4 className="text-sm font-medium text-foreground">{feature?.title}</h4>
                <p className="text-xs text-muted-foreground mt-1">{feature?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Certifications */}
      <div className="bg-card rounded-lg p-6 border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="Award" size={20} className="mr-2 text-primary" />
          Certifications & Compliance
        </h3>
        <div className="space-y-3">
          {certifications?.map((cert) => (
            <div key={cert?.id} className="flex items-center space-x-3 p-3 bg-muted/50 rounded-lg">
              <div className="flex-shrink-0 w-10 h-10 bg-success/10 rounded-lg flex items-center justify-center">
                <Icon name={cert?.icon} size={18} className="text-success" />
              </div>
              <div className="flex-1">
                <div className="flex items-center space-x-2">
                  <h4 className="text-sm font-medium text-foreground">{cert?.name}</h4>
                  {cert?.verified && (
                    <Icon name="CheckCircle" size={14} className="text-success" />
                  )}
                </div>
                <p className="text-xs text-muted-foreground">{cert?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Technology Partners */}
      <div className="bg-card rounded-lg p-6 border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="Handshake" size={20} className="mr-2 text-primary" />
          Technology Partners
        </h3>
        <div className="space-y-3">
          {partnerships?.map((partner) => (
            <div key={partner?.id} className="flex items-center space-x-3 p-3 bg-muted/50 rounded-lg">
              <div className="flex-shrink-0 w-12 h-8 bg-white rounded border overflow-hidden">
                <Image 
                  src={partner?.logo} 
                  alt={partner?.name}
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h4 className="text-sm font-medium text-foreground">{partner?.name}</h4>
                <p className="text-xs text-muted-foreground">{partner?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Client Testimonials */}
      <div className="bg-card rounded-lg p-6 border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="MessageSquare" size={20} className="mr-2 text-primary" />
          Trusted by Leading Organizations
        </h3>
        <div className="space-y-4">
          {testimonials?.map((testimonial) => (
            <div key={testimonial?.id} className="p-4 bg-muted/50 rounded-lg">
              <p className="text-sm text-foreground mb-3 italic">
                "{testimonial?.content}"
              </p>
              <div className="flex items-center space-x-3">
                <Image 
                  src={testimonial?.avatar} 
                  alt={testimonial?.name}
                  className="w-8 h-8 rounded-full"
                />
                <div>
                  <h4 className="text-sm font-medium text-foreground">{testimonial?.name}</h4>
                  <p className="text-xs text-muted-foreground">{testimonial?.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Contact Information */}
      <div className="bg-primary/5 rounded-lg p-6 border border-primary/20">
        <h3 className="text-lg font-semibold text-foreground mb-4 flex items-center">
          <Icon name="MapPin" size={20} className="mr-2 text-primary" />
          Local Ugandan Company
        </h3>
        <div className="space-y-3 text-sm">
          <div className="flex items-center space-x-2">
            <Icon name="Building" size={16} className="text-primary" />
            <span className="text-foreground">Registered in Kampala, Uganda</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Phone" size={16} className="text-primary" />
            <span className="text-foreground">+256 700 123 456</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Mail" size={16} className="text-primary" />
            <span className="text-foreground">info@techtribes.ug</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Globe" size={16} className="text-primary" />
            <span className="text-foreground">Serving Uganda since 2020</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;